import { createSlice } from '@reduxjs/toolkit'

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    value: {},
  },
  reducers: {
    updateUser: (state, newValue) => {
      state.value = newValue.payload
    },
  },
})

export const { updateUser } = userSlice.actions

export const selectUser = (state) => state.user.value

export default userSlice.reducer